import { postRequest } from '../clients/axios';
import { SavePlayerPayload } from '../models';

export const postSavePlayer = async (data: SavePlayerPayload) => {
  const url = 'player/saveplayer';
  const response = await postRequest<any>(url, data);
  return response;
};
